import React from 'react';
import { Stack } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { formatPrice } from '../../../lib/formatPrice';
import { getRoundedMarkdownPercent } from '../../../lib/variantUtils/getRoundedMarkdownPercent';

import './LineItemPrice.scss';

type Props = {
  direction: 'vertical' | 'horizontal';
  item: LineItem;
};

export const LineItemPrice: React.FC<Props> = ({
  direction,
  item: {
    attributes: {
      isTrunkshow,
      isPreorder,
      prices: { originalPrice, currentPrice: currentSinglePrice, depositPrice, isDiscounted },
      quantity
    }
  }
}) => {
  // TODO: this should be calculated correctly on the back-end
  const currentPrice = {
    ...currentSinglePrice,
    price: quantity * Number(currentSinglePrice.price)
  };

  const markdownPercent = getRoundedMarkdownPercent({
    currentPrice: Number(currentPrice.price),
    originalPrice: Number(originalPrice.price)
  });

  return (
    <Stack className="LineItemPrice" space={1} direction={direction} data-testid="lineItemPrice">
      {isDiscounted && (
        <div className="LineItemPrice__original">
          {formatPrice(originalPrice.currency, originalPrice.price)}
        </div>
      )}
      <div>{formatPrice(currentPrice.currency, currentPrice.price)}</div>
      {(isTrunkshow || isPreorder) && (
        <div>({formatPrice(depositPrice.currency, depositPrice.price)} Deposit)</div>
      )}
      {isDiscounted && (
        <div className="LineItemPrice__markdown-percent">Save {markdownPercent}%</div>
      )}
    </Stack>
  );
};
